import {
  CARD_BORDER,
  CARD_PADDING,
  CARD_RADIUS,
  CARD_SHADOW,
  INNER_SUBCARD_PADDING,
  INNER_SUBCARD_RADIUS,
  INNER_SUBCARD_SHADOW,
  SUBCARD_PADDING,
  SUBCARD_RADIUS,
  SUBCARD_SHADOW,
} from "@packages/design-system/constants";
import React from "react";

export default function Card({
  variant,
  noPadding,
  noBottomPadding,
  noTopPadding,
  background = "default",
  className,
  as = "div",
  id,
  children,
}: {
  children?: React.ReactNode;
  variant?: "sub" | "visualEmbed"; // Use "sub" for subCard, "visualEmbed" for visual embed like a FAQ video or image
  noPadding?: boolean;
  noBottomPadding?: boolean;
  noTopPadding?: boolean;
  background?: "default" | "error" | "warning" | "gradient" | "gradientLight";
  className?: string;
  as?: "div" | "section" | "nav" | "aside";
  id?: string;
}) {
  const subCard = variant === "sub";
  const visualEmbed = variant === "visualEmbed";

  // Force as="div" if subCard is true
  const Wrapper = subCard ? "div" : as;

  // Determine card styling based on variant
  let cardRadius: string;
  let cardPadding: string;
  let cardShadow: string;

  if (visualEmbed) {
    cardRadius = INNER_SUBCARD_RADIUS;
    cardPadding = INNER_SUBCARD_PADDING;
    cardShadow = INNER_SUBCARD_SHADOW;
  } else if (subCard) {
    cardRadius = SUBCARD_RADIUS;
    cardPadding = SUBCARD_PADDING;
    cardShadow = SUBCARD_SHADOW;
  } else {
    cardRadius = CARD_RADIUS;
    cardPadding = CARD_PADDING;
    cardShadow = CARD_SHADOW;
  }

  let paddingClass = "";
  if (!noPadding) {
    paddingClass = cardPadding;
    if (noTopPadding) {
      paddingClass += " !pt-0";
    }
    if (noBottomPadding) {
      paddingClass += " !pb-0";
    }
  }

  return (
    <Wrapper
      id={id}
      className={`divide-border-light relative w-full divide-y overflow-hidden ${CARD_BORDER} ${cardRadius} ${cardShadow} ${
        background === "gradient"
          ? "from-secondary/15 via-secondary/30 to-secondary/70 bg-gradient-to-b"
          : background === "gradientLight"
            ? "from-secondary-light/30 via-secondary-light/50 to-secondary-light/80 bg-gradient-to-b"
            : background === "warning"
              ? "bg-yellow-50 text-yellow-700"
              : background === "error"
                ? "bg-destructive-foreground text-destructive"
                : "bg-background text-foreground"
      } ${className ?? ""}`}
    >
      <div className={paddingClass}>{children}</div>
    </Wrapper>
  );
}
